import { Stack, Box } from '@mantine/core';
import { AppHeader } from './AppHeader';
import { AppFooter } from './AppFooter';
import { FloatingContactButton } from '../Contact';

interface PageLayoutProps {
  children: React.ReactNode;
}

export const PageLayout = ({ children }: PageLayoutProps) => {
  return (
    <Stack gap={0} style={{ minHeight: '100vh' }}>
      <Box
        component="header"
        h={{ base: 56, sm: 60 }}
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          backgroundColor: 'var(--mantine-color-body)',
        }}
      >
        <AppHeader />
      </Box>

      <Box
        component="main"
        px={{ base: 'xs', sm: 'md' }}
        pb={{ base: 'xl', sm: '3rem' }}
        style={{ flex: 1 }}
      >
        {children}
      </Box>

      <AppFooter />
      <FloatingContactButton />
    </Stack>
  );
};